import React from "react";
import classes from "../RTGS/RTGS.module.css";

import { useNavigate } from "react-router-dom";
// import { Field, Form, Formik } from 'formik';
// import { LoginFormInitialValues, LoginFormValidation } from '../../validations/LoginFormValidation';
import { useForm, Controller } from "react-hook-form";
import { Box, Divider, Grid, TextField } from "@mui/material";
import { useContext, useState } from "react";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import styled from "styled-components";
import { Button } from "@mui/base";
import { RemoveRedEye } from "@mui/icons-material";

// import { useForm, Controller } from 'react-hook-form';
import Input from "@mui/material/Input"; // Assuming you're using Material-UI Input
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import TextFieldForm from "../../../../../components/common/textFieldForm";
import { postApiData } from "../../../../../components/utilities/nodeApiServices";
import { apiList } from "../../../../../components/utilities/nodeApiList";
import { errorMessages } from "../../../../../components/utilities/formValidation";
import AutocompleteForm from "../../../../../components/common/autuCompleteForm";
import { useLocation } from "react-router-dom/dist";
import SweetAlertPopup from "../../../../../components/common/sweetAlertPopup";
import UpdateNeftOtp from "./UpdateRTGSOtp";
import GoBackButton from "../../../../../components/common/GoBackButton";
import UpdateRTGSOtp from "./UpdateRTGSOtp";
import Loader from "../../../../../components/common/loader";
import { compareTextAndReturnObject, numberCommaFormat } from "../../../../../components/common/commonArray";
import { useLanguage } from "../../../../../context/LanguageContext";

const defaultFormData = {
  amount: "",
  tpin: "",
  remark: "",
};

const RTGSDetails = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [isLoading, setIsloading] = useState(false);
  const [response, setResponse] = useState("");
  const { state } = useLocation();
  const { loading, error, isAuthenticated, user } = useSelector(
    (state) => state.auth
  );
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [userId, setUserId] = useState("");
  const [payloads, setPayload] = useState("");
  const [accountBalance, setAccountBalance] = useState("");
  const [selectedAccountName, setSelectedAccountName] = useState("");
   const { t } = useLanguage();
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // console.log("state", state);
  const accountList =
    user?.accountDetails &&
    user?.accountDetails?.map((item) => ({
      code: item.brCode,
      value: item.accNo,
      name: item.name,
      acctype: item.acctype,
    }));
  useEffect(() => {
    if (state?.rowData[3] && state?.rowData[4] && state?.rowData[2]) {
      setValue("benaccno", state?.rowData[3]);
      setValue("benifsc", state?.rowData[4]);
      setValue("benename", state?.rowData[2]);
    }
  }, [state]);

  const defaultFormData = {
    Accountnumber: state?.accno,
    accName: state?.accName,
    // acctype: state?.acctype,
    benifsc: state?.rowData[4] ? state?.rowData[4] : "",
    benaccno: state?.rowData[3] ? state?.rowData[3] : "",
    benename: state?.rowData[2] ? state?.rowData[2] : "",
    amount: "",
    tpin: "",
    remark: "",
  };
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    register,
    watch,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: defaultFormData,
    mode: "onChange",
  });
  const navigate = useNavigate();
  const handlleNavigate = (route) => {
    navigate(route);
  };
  const popupAlert = (message, msgtype, msgicon) => {
    {
      Swal.fire({
        title: msgtype,
        text: message,
        icon: msgicon,
      });
    }
  };

  const beneficiary = [
    {
      code: 0,
      value: "ABC",
    },
    {
      code: 1,
      value: "XYZ",
    },
  ];

  const onSubmit = async (data) => {
    const payload = {
      amount: data.amount,
      tpin: data.tpin,
      custNo: user?.userId,
      sessionId: user?.sessionId,
      accNo: data?.accountNumber?.value,
      beneNickname: state?.rowData[1] ? state?.rowData[1] : "other",
      beneAccNo: data.benaccno,
      beneIfsc: data.benifsc,
      remark: data.remark,
    };
    setIsloading(true);
    const response = await postApiData(apiList.RTGSTRANSACTIONS, payload);
    // console.log("response", response);

    if (response?.status == true) {
      if (response?.data.respcode == "OTP") {
        setUserId(response?.data);
        setPayload(payload);
        handleOpen();
        setIsloading(false);
        setResponse(response);
      } else {
        reset();
        handlleNavigate('/fundtransfer/receipt', { data, response, accountList, accountHolderName: selectedAccountName });
      }
    } else if (response?.data?.tpinAttempt >= 0) {
      SweetAlertPopup(
        response?.message +
        "\n" +
        (response?.data.tpinAttempt + 1) +
        " Attempts Remaining",
        "Error",
        "error"
      );
      setIsloading(false);
    } else if (response?.status == false) {

      if (!response?.data?.txnData) {
       
        SweetAlertPopup(response?.message, "Error", "error");
        setIsloading(false);
        return; 
      }
      else {
        handlleNavigate('/fundtransfer/receipt', { data, response, accountList, accountHolderName: selectedAccountName });
        setIsloading(false);
      }
      // SweetAlertPopup(response?.message, "Error", "error");

    } else {
      SweetAlertPopup(response?.message, "Error", "error");
      setIsloading(false);
    }
  };

  useEffect(() => {
    if (accountList) {
      // setValue("accName", accName)
      setValue(
        "accountNumber",
        accountList
          ? compareTextAndReturnObject(accountList, accountList[0]?.value)
          : ""
      );
    }
  }, []);

  const accountNumber = watch("accountNumber");

  const fetchBalance = async (data) => {
    try {
      setIsloading(true);
      const payload = {
        accNo: watch("accountNumber") ? watch("accountNumber")?.value : "",
        custNo: user?.userId,
        sessionId: user?.sessionId,
      };
      const response = await postApiData(apiList.FETCHBAL, payload);
      if (response?.status == true) {
        setAccountBalance(response?.data);
        setIsloading(false);
      } else {
        setIsloading(false);
      }
    } catch (err) {
      //   console.log(err)
      setIsloading(false);
    }
  };

  useEffect(() => {
    if (accountNumber) {
      fetchBalance();
    }
  }, [accountNumber]);

  useEffect(() => {
    const accountNumber = watch("accountNumber");
    if (accountNumber) {
      const account = accountList.find(
        (acc) => acc.value === watch("accountNumber").value
      );
      if (account) {
        console.log("Set value run");
        setSelectedAccountName(account.name);
        setValue("acctype", account.acctype);
        setValue("accName", account.name);
      }
    }
  }, [watch("accountNumber"), accountList]);
  const ColorButton1 = styled(Button)(({ theme }) => ({
    color: "#FFFFFF",
    // backgroundColor: "#F84B67",
    // backgroundColor: "#323232",
    background: "var(--button-color)",
    border: "1px solid #CCC",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "153px",
    height: "35px",
    "&:hover": {
      background: "var(--button-hover-color)",
      color: "white",
    },
  }));
  const ColorButton2 = styled(Button)(({ theme }) => ({
    color: "#707070",

    // backgroundColor: "#F84B67",
    // backgroundColor: "#323232",
    background: "#FFF",
    border: "1px solid #707070",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "183px",
    height: "40px",
    "&:hover": {
      background: "#808080",
      color: "white",
    },
  }));

  return (
    <>
      {isLoading ? <Loader loading={true} /> : <Loader loading={false} />}
      <div className={classes.redrow}>

        <div style={{ display: "flex", alignItems: "center", gap: '5px' }}>
          <GoBackButton />
          <div className={classes.SubHeading}>
            {t("rtgs_heading")}
          </div>
        </div>
      </div>


      <div className={classes.sbox}>
        <Box
          className={classes.box1}
          component="form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className={classes.firsttabinfo}>
            <Grid
              container
              columnSpacing={4}
              rowSpacing={2}
              style={{ padding: "0.1vw" }}
            >
              {/*            
              <Grid item xs={12} sm={12} md={12}>
                <ColorButton1 variant="contained" type="submit">
                  Instant Pay
                </ColorButton1>
              </Grid> */}

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.beneficiarytitle}
              >
                <div className={classes.headingRemitter}>
                  {t("remitterDetails")}
                </div>
              </Grid>

              <Grid item xs={12} sm={12} md={4}>
                <div className={classes.frowdataaff}>
                  <div className={classes.frowtextaff}>
                    {t("accountNumberLabel")}<sup className={classes.required}>*</sup>
                  </div>
                  <AutocompleteForm
                    controlerProps={{
                      control: control,
                      name: "accountNumber",
                    }}
                    TextFieldProps={{
                      placeholder: t("accountNumberLabelPlaceholder"),
                      onKeyDown: (event) => {
                        // const regex = /^[0-9]*$/;
                        const regex = /^[a-zA-Z0-9]*$/;
                        const isBackspace = event.keyCode === 8;
                        const isValidInput = regex.test(event.key);

                        const currentInputValue = event.target.value;

                        // Maximum length constraint
                        const maxLength = 32; // Set your max length here
                        const isMaxLengthReached =
                          currentInputValue.length >= maxLength;

                        if (
                          (!isValidInput && !isBackspace) ||
                          (isMaxLengthReached && !isBackspace)
                        ) {
                          event.preventDefault();
                        }
                      },
                    }}
                    rules={{
                      required:
                        t("account_required")

                      // maxLength: {
                      //   value: 32, // Set your max length here
                      //   message:
                      //     "Account Number must be no more than 10 digits long",
                      // },
                    }}
                    data={accountList}
                    required={true}
                  />
                  <div className={classes.availablebalance}>{t("availableBalance")} <span className={classes.balace}>₹ {numberCommaFormat(accountBalance?.accBal)}</span></div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.frowdataaff}>
                  <div className={classes.frowtextaff}>
                    {t("accountTypeLabel")}
                    <sup className={classes.required}>*</sup>
                  </div>
                  <div className={classes.widthtfield}>
                    <TextFieldForm
                      controlerProps={{
                        control: control,
                        name: "acctype",
                        rows: 5,
                        maxRows: 10,
                      }}
                      TextFieldProps={{
                        // label: "Branch",
                        placeholder: t("accountTypeLabel"),
                        //   style: { width: "130%" },
                        fullWidth: true,
                        // style:{border:'3px solid #ECECEC'}
                        disabled: state?.rowData[3] ? true : false,
                        inputProps: { maxLength: 32 },
                      }}
                      backgroundColor={true}
                      regExp={/^[0-9A-Za-z]*$/}
                      rules={{
                        required:
                          t("accountType_required"),
                      }}
                      required={true}
                    />
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.frowdataaff}>
                  <div className={classes.frowtextaff}>
                    {t("accountHolderName")}
                    <sup className={classes.required}>*</sup>
                  </div>
                  <div className={classes.widthtfield}>
                    <TextFieldForm
                      controlerProps={{
                        control: control,
                        name: "accName",
                        rows: 5,
                        maxRows: 10,
                      }}
                      TextFieldProps={{
                        // label: "Branch",
                        placeholder: t("accountHolderName"),
                        //   style: { width: "130%" },
                        fullWidth: true,
                        // style:{border:'3px solid #ECECEC'}
                        disabled: state?.rowData[4] ? true : false,
                      }}
                      backgroundColor={true}
                      regExp={/^[a-zA-Z0-9]+$/}
                      rules={{
                        required:
                         t("accountHolderName_required"),
                      }}
                      required={true}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Divider />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.beneficiarytitle}
              >
                <div className={classes.headingRemitter}>
                  {t("beneficiaryDetails")}
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.frowdataaff}>
                  <div className={classes.frowtextaff}>
                    {t("beneficiaryAccountNumber")}
                    <sup className={classes.required}>*</sup>
                  </div>
                  <div className={classes.widthtfield}>
                    <TextFieldForm
                      controlerProps={{
                        control: control,
                        name: "benaccno",
                        rows: 5,
                        maxRows: 10,
                      }}
                      TextFieldProps={{
                        // label: "Branch",
                        placeholder: t("beneficiaryAccountNumber"),
                        //   style: { width: "130%" },
                        fullWidth: true,
                        // style:{border:'3px solid #ECECEC'}
                        disabled: state?.rowData[3] ? true : false,
                        inputProps: { minLength: 1, maxLength: 32 },
                      }}
                      backgroundColor={true}
                      regExp={/^[a-zA-Z0-9]*$/}
                      rules={{
                        required:
                          t("beneficiaryAccountNumber_required"),
                      }}
                      required={true}
                    />
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.frowdataaff}>
                  <div className={classes.frowtextaff}>
                    {t("beneficiaryIFSC")}
                    <sup className={classes.required}>*</sup>
                  </div>
                  <div className={classes.widthtfield}>
                    <TextFieldForm
                      controlerProps={{
                        control: control,
                        name: "benifsc",
                        rows: 5,
                        maxRows: 10,
                      }}
                      TextFieldProps={{
                        // label: "Branch",
                        placeholder: t("beneficiaryIFSC"),
                        //   style: { width: "130%" },
                        fullWidth: true,
                        // style:{border:'3px solid #ECECEC'}
                        disabled: state?.rowData[4] ? true : false,
                        inputProps: { maxLength: 11 },
                      }}
                      backgroundColor={true}
                      regExp={/^[a-zA-Z0-9]+$/}
                      rules={{
                        required:
                          t("beneficiaryIFSC_required"),
                        // pattern: {
                        //   value: /^[A-Z]{4}0[0-9]{7}$/,
                        //   message: "Please Enter valid format of IFSC Number",
                        // },
                        pattern: {
                          value: /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/,
                          message: t("validIFSC"),
                        },
                      }}
                      required={true}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.frowdataaff}>
                  <div className={classes.frowtextaff}>
                    {t("beneficiaryName")}
                    <sup className={classes.required}>*</sup>
                  </div>
                  <div className={classes.widthtfield}>
                    <TextFieldForm
                      controlerProps={{
                        control: control,
                        name: "benename",
                        rows: 5,
                        maxRows: 10,
                      }}
                      TextFieldProps={{
                        // label: "Branch",
                        placeholder: t("beneficiaryName"),
                        //   style: { width: "130%" },
                        fullWidth: true,
                        // style:{border:'3px solid #ECECEC'}
                        disabled: state?.rowData[2] ? true : false,
                      }}
                      backgroundColor={true}
                      regExp={/^[a-zA-Z0-9]+$/}
                      rules={{
                        required:
                          t("beneficiaryName_required"),
                        // pattern: {
                        //   value: /^[A-Z]{4}0[0-9]{7}$/,
                        //   message: "Please Enter valid format of IFSC Number",
                        // },
                      }}
                      required={true}
                    />
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Divider />
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.beneficiarytitle}
              >
                <div className={classes.headingRemitter}>
                  {t("transferDetails")}
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.frowdataaff}>
                  <div className={classes.frowtextaff}>
                    {t("amount")}
                    <sup className={classes.required}>*</sup>
                  </div>
                  <div className={classes.widthtfield}>
                    <TextFieldForm
                      controlerProps={{
                        control: control,
                        name: "amount",
                        rows: 5,
                        maxRows: 10,
                      }}
                      TextFieldProps={{
                        // label: "Branch",
                        placeholder: t("amount"),
                        //   style: { width: "130%" },
                        fullWidth: true,
                        // style:{border:'3px solid #ECECEC'}
                        inputProps: { maxLength: 19 },
                      }}
                      // backgroundColor={true}
                      regExp={/^[0-9.]*$/}
                      // regExp={/^\d{1,11}(\.\d{1,2})?$/}
                      rules={{
                        required: t("amount_required"),
                        pattern: {
                          value: /^\d{1,16}(?:\.\d{1,2})?$/,
                          message: t("validAmount"),
                        },
                      }}
                      required={true}
                    />
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                {/* <div className={classes.frowdataaff}>
                    <div className={classes.frowtextaff}>
                      TPIN
                      <sup className={classes.required}>*</sup>
                    </div>
                    <div className={classes.widthtfield}>
                      <TextFieldForm
                        controlerProps={{
                          control: control,
                          name: "tpin",
                          rows: 5,
                          maxRows: 10,
                        }}
                        TextFieldProps={{
                          // label: "Branch",
                          placeholder: "Enter Tpin ",
                          //   style: { width: "130%" },
                          fullWidth: true,
                          // style:{border:'3px solid #ECECEC'}
                          inputProps: { maxLength: 4 },
                        }}
                        backgroundColor={true}
                        regExp={/^[0-9]*$/}
                        rules={{
                          required:
                            "  Tpin " +
                            errorMessages.error_autocomplete_message,
                          pattern: {
                            value: /^\d{4}$/,
                            message: "Please Enter valid TPIN",
                          },
                        }}
                        required={true}
                      />
                    </div>
                  </div> */}
                <div className={classes.frowtextaff}>
                  {t("tpin")} <sup className={classes.required}>*</sup>
                </div>
                <div className={classes.frow1aff}>
                  <Controller
                    name="tpin" // The name should match the key in 'data' object in onSubmit
                    control={control}
                    defaultValue="" // Set an initial value if needed
                    rules={{
                      required:
                        t("tpin_required"),
                      pattern: {
                        value: /^[0-9]{4,}$/, // This pattern allows only digits and requires at least 4 digits
                        message:
                          t("tpin_info"),
                      },
                    }}
                    render={({ field, fieldState }) => {
                      const handleInputChange = (event) => {
                        const regex = /^[0-9]+$/;
                        const { name, value } = event.target;
                        const isValidInput =
                          regex.test(value) || value === "";

                        if (!isValidInput) {
                          event.preventDefault();
                          return;
                        }

                        field.onChange(value);
                      };

                      return (
                        <TextField
                          id="standard-adornment-password"
                          fullWidth="true"
                          placeholder="Enter TPIN "
                          maxLength={4}
                          type={showPassword ? "text" : "password"}
                          {...field} // Spread the 'field' props to bind it to the form's state
                          sx={{
                            "& fieldset": { border: "none" },
                            ".MuiInputBase-root": {
                              borderRadius: "6px",
                              position: "relative",
                              // backgroundColor: theme.palette.mode === 'light' ? '#F3F6F9' : '#1A2027',
                              backgroundColor: "#FFF",
                              // backgroundColor: backgroundColor?'#FFF' : "#EEEFF7",
                              marginTop: "4px",

                              border: "1px solid",
                              // borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
                              // borderColor: 'red',
                              fontSize: "13px",
                              height: "24px",
                              color: "#888",
                              fontWeight: "500",

                              // width: '520px',
                              padding: "14px 0px",
                            },
                          }}
                          inputProps={{ maxLength: 4, minLength: 4 }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                >
                                  {!showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          error={!!fieldState.error}
                          helperText={fieldState.error?.message}
                          onChange={handleInputChange}
                        // error={field.error} // Pass the error state here
                        // helperText={passwordError ? "Password does not meet requirements" : ""}
                        />
                      );
                    }}
                  />
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.frowdataaff}>
                  <div className={classes.frowtextaff}>
                    {t("remark")}
                    <sup className={classes.required}>*</sup>
                  </div>
                  <div className={classes.widthtfield}>
                    <TextFieldForm
                      controlerProps={{
                        control: control,
                        name: "remark",
                        rows: 5,
                        maxRows: 10,
                      }}
                      TextFieldProps={{
                        // label: "Branch",
                        placeholder: t("remark"),
                        //   style: { width: "130%" },
                        fullWidth: true,
                        // style:{border:'3px solid #ECECEC'}
                        // disabled: state?.benelist.ifsc ? true : false,
                      }}
                      // backgroundColor={true}
                      regExp={/^[a-zA-Z0-9., ]+$/}
                      rules={{
                        required:
                          t("remark_required"),
                      }}
                      required={true}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12}></Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <ColorButton1 variant="contained" type="submit">
                {t("continue_Button")}
              </ColorButton1>
            </Grid>
          </div>

          {/* <div className={classes.payment1mobileprepaidbutton} >
                <ColorButton2 variant="contained" type="submit">
                Reset
                </ColorButton2>
                <ColorButton1 variant="contained" type="submit">
                Continue
                </ColorButton1>
              
             
        
            </div> */}
        </Box>

        {open ? (
          <UpdateRTGSOtp
            open={open}
            handleClose={handleClose}
            userId={userId}
            payloads={payloads}
            response={response}
            selectedAccountName={selectedAccountName}
          />
        ) : null}
      </div>

    </>
  );
};

export default RTGSDetails;
